import { useEffect, useRef } from 'react';

import { useFormContext } from 'react-hook-form';

import type { PropertyFormContext } from '@modules/_shared/components/property-form/forms-definitions/propertyDetailsFormDefinition';
import type { PropertyFormData } from '@modules/_shared/components/property-form/propertyFormDefinition';
import { useWatchMultiple } from '@modules/_shared/utils/reactHookForm';

export const PropertyTypeProvider: React.FC<{
  propertyTypes: PropertyFormContext['propertyTypes'];
}> = ({ propertyTypes }) => {
  const { __main_type, property_type_id } = useWatchMultiple<
    PropertyFormData,
    '__main_type' | 'property_type_id'
  >({ name: ['__main_type', 'property_type_id'] });

  const { setValue } = useFormContext<PropertyFormData>();
  const prevMainTypeRef = useRef(__main_type);

  useEffect(() => {
    const mainTypeChanged = prevMainTypeRef.current !== __main_type;
    prevMainTypeRef.current = __main_type;

    if (__main_type == null || property_type_id == null) {
      setValue('__property_type', null);
    } else {
      const matchingType = propertyTypes.find(
        pt => pt.id === property_type_id && pt.main_type === __main_type,
      );

      if (matchingType == null) {
        if (mainTypeChanged && propertyTypes.length > 0) {
          setValue('property_type_id', null, {
            shouldValidate: true,
            shouldDirty: true,
          });
        }
        setValue('__property_type', null);
      } else {
        setValue('__property_type', {
          main_type: __main_type,
          name: matchingType.name,
        });
      }
    }
  }, [__main_type, property_type_id, propertyTypes, setValue]);

  return null;
};
